import { Component, OnInit } from '@angular/core';
import { ActionSheetController, NavController, ToastController } from '@ionic/angular';
import { msgfunc } from '../../../providers/msgfunc';
import { GlobalVars } from '../../../providers/globalVars';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase} from '@angular/fire/database';
@Component({
  selector: 'app-inquiry',
  templateUrl: './inquiry.page.html',
  styleUrls: ['./inquiry.page.scss'],
})
export class InquiryPage implements OnInit {
    btmtoolbar:any;
  isAnony = false;
  type:any = "문의항목 선택";
  title:any = '';
  message:any = '';
  toptitle:any;
  // @ViewChild(AngularEditorComponent) editor:AngularEditorComponent;
  constructor(
   private actionsheetCtrl:ActionSheetController,public navCtrl: NavController,private route: ActivatedRoute,
   private afDB:AngularFireDatabase,
   private toastCtrl:ToastController ,public gv:GlobalVars,private msgfunc:msgfunc
  ) { }

  ngOnInit() {
    if(this.route.snapshot.paramMap.get('id'))
    {
      this.toptitle = "맞춤광고 문의";
      this.afDB.database.ref('/pmall/' + this.route.snapshot.paramMap.get('id')).once('value').then(rst=>{
        this.title = '광고문의] ' + rst.val().title;
        this.type = null;
      })
    }
  }

  async slttype(){
     const actionSheet = await this.actionsheetCtrl.create({
      header: '문의타입 선택',
      buttons: [{
        text: '이용문의',
        handler: () => {
          this.type  = '이용문의';
        }
      }, {
        text: '불편사항',
        handler: () => {
          this.type  = '불편사항';
        }
      }, {
        text: '업무제휴',
        handler: () => {
          this.type  = '업무제휴';
        }
        }, {
        text: '기타문의',
        handler: () => {
          this.type  = '기타문의';
        }
      }]
    })
    await actionSheet.present();
  }

  send(){
    if(this.message.trim())
    {
    let msg = (this.type?"["+this.type+"]\n":'') + (this.title?this.title+"\n":'') + this.message;
    if(this.isAnony)
      {
      this.msgfunc.sendmsg('anonymous', 'NjQizqLkBINRT9LF9oHjmMing403', msg, '익명');
      this.presentToast('의견을 익명으로 전달하였습니다.');
      this.navCtrl.pop();
      }
    else
      {
      this.msgfunc.sendmsg(this.gv.uid?this.gv.uid:'no uid', 'NjQizqLkBINRT9LF9oHjmMing403', msg, this.gv.unickname?this.gv.unickname:'No nickname');
      this.presentToast('문의가 접수되었습니다.');
      this.navCtrl.pop();
      }
    }
    else{
      this.presentToast('내용은 반드시 작성하셔야 합니다.');
    }
  }

  async presentToast(message: string) {
    const toast = await this.toastCtrl.create({
      message: message,
      position: 'bottom',
      duration: 2200
    });
    return await toast.present();
  }


}
